


















import { defineComponent, reactive, SetupContext, computed, onMounted, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

interface Data {
  dragAreaText: string
  errors: string[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      dragAreaText: null,
      errors: [],
    });

    /******************************
     * 戻るボタン押下
     ******************************/

    const goBack = (): void => {
      context.root.$router.go(-1);
    };

    /******************************
     * アップロードAPI
     ******************************/

    const upload = async (file: File[]): Promise<void> => {

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append("sheet_type", context.root.$store.state.sheet_type);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post("/api/teacher/ikkatsu_question_upload/upload", fd).then(response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // 教材は模範解答なし
      if(context.root.$store.state.sheet_type == Common.SheetTypeEnum.Report){
        state.dragAreaText = `
          問題用紙のJPEG又はPDFをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。（ファイルの拡張子は複数混在できません）<br>
          JPEGのファイル命名規則：rm + QRコード + ページ番号(0埋2桁).jpg　例＞rm22001100010101.jpg<br>
          PDFのファイル命名規則：rm + QRコード.pdf　例＞rm220011000101.jpg
        `
      }else if(context.root.$store.state.sheet_type == Common.SheetTypeEnum.LessonTest){
        state.dragAreaText = `
          問題用紙のJPEG又はPDFをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。（ファイルの拡張子は複数混在できません）<br>
          JPEGのファイル命名規則：tm + 講座コード + 回次(0埋3桁) + ページ番号(0埋2桁).jpg　例＞tmSU010100201.jpg<br>
          PDFのファイル命名規則：tm + 講座コード + 回次(0埋3桁).pdf　例＞tmSU0101002.pdf
        `
      }
    });

    return {
      ...toRefs(state),
      goBack,
      upload,
    };
  },
})
